import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-offer-add',
  templateUrl: './offer-add.component.html',
  styleUrls: ['./offer-add.component.css']
})
export class OfferAddComponent implements OnInit {

  cid:any;
  form: any | FormGroup;
  addButton = false;
  formSubmitted = false;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.form = this.fb.group({
      name: ['',[Validators.required]],
      description: ['',[Validators.required]],
    })
  }


  addOffer(){
    this.formSubmitted = true;
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }
    this.addButton = true;

    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "name": String(this.form.get('name').value),
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.addOffer(body).subscribe(
      (response:any) => {
        console.log(response)
        this.cancelModel()
        this.form.reset()
        this.toastr.success(response.message)
        this.addButton = false;
        this.formSubmitted = false;
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
        this.addButton = false;
      }
    )
  }


  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  clear(){
    this.form.reset()
  }

}